module.exports = __webpack_public_path__ + "img/thanks_image_sended.77389eb.svg";